import request from '../utils/request'

// 动态详情
export function xzVipApply (data) {
  return request({
    url: 'member/apply',
    method: 'POST',
    data
  })
}

export function createGoodsFeedback (params) {
  return request({
    method: 'post',
    url: 'goods_feedback/create',
    data: params
  })
}
